var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDothereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.6 112.7c-8.1-0.3-9.1-0.5-10.3-2.3C40.5 107.5 18.4 22.5 18.8 19.9 19 18 21.1 16.9 32 12.5 39.1 9.6 45.5 7.2 46.2 7.2 47.8 7.1 103.7 46.7 104.3 48.3c0.3 0.7-6.1 15.6-14.1 33.2l-14.5 31.9-7.1-0.2C64.8 113.1 57.6 112.9 52.6 112.7Zm16.2-1.8c-0.6-0.3-1.9-0.3-2.8 0-0.9 0.2-0.4 0.4 1.1 0.5 1.5 0 2.3-0.2 1.6-0.4zm1.6-3c0-0.8-20.9-81.6-23.6-91.3l-1.3-4.8-11.3 4.4c-9.3 3.7-11.3 4.7-11 6.1 0.3 1.7 21.1 80.8 21.9 83.7 0.3 0.9 1.4 1.7 2.5 2 4.2 0.8 22.8 0.6 22.8-0.2zM98 52.9c-0.2-0.2-4.8 0.7-10.1 2.2l-9.7 2.6-5.7 9.5-5.7 9.5 3.7 14.7 3.7 14.7 12-26.4C93 65.1 98.2 53.1 98 52.9Zm-24.8 3.9c0-0.8-13-9.3-13.4-8.8-0.2 0.2 1 5.3 2.6 11.5l2.9 11.2 3.9-6.6c2.2-3.6 3.9-6.9 3.9-7.3zM89.8 50.2 97.6 48.1 74.6 31.7C62 22.7 51.5 15.5 51.3 15.7c-0.2 0.2 1.2 6 3.1 12.9l3.5 12.6 9.2 6c10.4 6.7 9.5 6.6 22.6 3z",
    strokeWidth: 0.9,
    color: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDothereum);
export default __webpack_public_path__ + "static/media/dothereum.07a528dd874ce0f2f45964db2584b4a8.svg";
export { ForwardRef as ReactComponent };